import { HttpErrorResponse } from '@angular/common/http';
import { Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { HotToastService } from '@ngneat/hot-toast';
import { CountryDto, RegionDto, RegTransferPaymentDto, TestSessionForRegistrationDto, UserAccountRegDto, UserTestRegistrationTransferRequest } from 'src/app/core/dtos/dto';
import { HttpErrorResponseMessages } from 'src/app/core/dtos/http-error-response-messages';
import { AccountService } from 'src/app/core/services/account.service';
import { CountryRegionService } from 'src/app/core/services/country-region.service';
import { ConfigHelper } from 'src/app/core/services/helpers/config.helper';
import { BrandEnum, DeliveryMethodEnum, TestTypeEnum } from 'src/app/core/dtos/enum';
import { ModalComponent } from 'src/app/shared/components/modal/modal.component';

@Component({
  selector: 'app-transfer-registration',
  templateUrl: './transfer-registration.component.html',
  styleUrls: ['./transfer-registration.component.scss']
})

export class TransferRegistrationComponent implements OnInit {
  @ViewChild('confirmationModal') confirmationModal: ModalComponent;
  brandId: BrandEnum;
  brandName: string;
  regId: number;
  testRegInfo: UserAccountRegDto;
  selectedCountry: CountryDto;
  convertedTestRegDateFromUTCToLocal: Date;
  countries: CountryDto[];
  confirmMessage: string;
  localTimeZone: string;
  stepNumberRegion: string;
  stepNumberTestCentre: string;
  stepNumberSitting: string;
  testTypeId: number;
  selectedRegion: RegionDto;
  regions: RegionDto[];
  sittingId: number;
  sittings: TestSessionForRegistrationDto[];
  testCentre: TestSessionForRegistrationDto;
  testCentres: TestSessionForRegistrationDto[];
  sittingsForSelectedTestCentre: TestSessionForRegistrationDto[];
  transferPaymentReturned: boolean;
  transferPayment: RegTransferPaymentDto;
  transferFee: number;
  showRegion: boolean;
  showTestCentre: boolean;

  sittingLocalDateMap: Record<number, Date> = {};
  constructor(
    private accountService: AccountService,
    private actRoute: ActivatedRoute,
    private configHelper: ConfigHelper,
    private countryRegionService: CountryRegionService,
    private toastService: HotToastService,
    private router: Router,
  ) {
    this.regId = Number(this.actRoute.snapshot.params.regId);
  }

  ngOnInit(): void {
    this.brandId = this.configHelper.getBrandId();
    this.brandName = this.configHelper.getBrandName();
    if (this.brandId === BrandEnum.CELPIP) {
      this.stepNumberRegion = "2";
      this.stepNumberTestCentre = "3";
      this.stepNumberSitting = "4";
    } else {
      this.stepNumberRegion = "1";
      this.stepNumberTestCentre = "2";
      this.stepNumberSitting = "3";
    }
    this.getRegistrationDetails(this.regId);
  }

  public get BrandEnum() {
    return BrandEnum;
  }
  convertUTCDateToLocalDate(date: Date): Date {
    return new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours(), date.getMinutes(), date.getSeconds()));
  }

  getLocalTimeZone(): string {
    return Intl.DateTimeFormat().resolvedOptions().timeZone;
  }

  getRegistrationDetails(regId: number) {
    this.accountService.getRegistrationDetails(regId)
      .subscribe(result => {
        this.testRegInfo = result.content;
        this.testTypeId = Number(this.testRegInfo.testTypeId);
        if (this.testRegInfo.isWebDelivery) {
          this.localTimeZone = this.getLocalTimeZone();
          this.convertedTestRegDateFromUTCToLocal = this.convertUTCDateToLocalDate(new Date(this.testRegInfo.testDateTimeUtc));
          this.getWebDeliverySittings(regId);
        } else {
          if (this.brandId === BrandEnum.CAEL) {
            this.getTransferRegions();
          } else {
            this.getCountries();
          }
        }
      },
        (error: HttpErrorResponse) => {
          if (error.status === 400) {
            const errorMessage = error.error as HttpErrorResponseMessages;
            errorMessage.reasons.forEach(reasons => {
              this.toastService.warning(reasons.errorMessage);
            });
          }
        });

  }

  getCountries() {
    this.countryRegionService.getCountriesWithActiveTestCentres()
      .subscribe(result => {
        this.countries = result.content;
        this.selectedCountry = this.countries[0];
        this.getCountrySittings();
      },
        (error: HttpErrorResponse) => {
          if (error.status === 400) {
            const errorMessage = error.error as HttpErrorResponseMessages;
            errorMessage.reasons.forEach(reasons => {
              this.toastService.warning(reasons.errorMessage);
            });
          }
        });
  }

  getWebDeliverySittings(regId: number) {
    this.transferPaymentReturned = false;
    this.transferFee = 0.0;
    this.accountService.getTargetRegTransferSessions(regId, 0)
      .subscribe(result => {
        this.sittings = result.content;
        for (const sitting of this.sittings) {
          this.sittingLocalDateMap[sitting.id] = this.convertUTCDateToLocalDate(new Date(sitting.testDateTimeUtc));
        }
        this.testCentres = this.getTestCentres(this.sittings);
        if (this.testCentres.length) {
          this.testCentre = this.testCentres[0];
          this.updateSittingsForSelectedTestCentre(this.sittings, this.testCentre);
          this.sittingId = null;
        }
      },
        (error: HttpErrorResponse) => {
          if (error.status === 400) {
            const errorMessage = error.error as HttpErrorResponseMessages;
            errorMessage.reasons.forEach(reasons => {
              this.toastService.warning(reasons.errorMessage);
            });
          }
        });

  }
  getTestCentres(sittings: TestSessionForRegistrationDto[]): TestSessionForRegistrationDto[] {
    let sortedSittings = [];
    sittings.forEach((item) => {
      const i = sortedSittings.findIndex(x => x.testCentreName === item.testCentreName);
      if (i <= -1) {
        const pushSitting = {
          id: item.id,
          testCentreId: item.testCentreId,
          testCentreName: item.testCentreName,
          testCentreCity: item.testCentreCity
        } as TestSessionForRegistrationDto;
        sortedSittings.push(pushSitting);
      }
    });
    sortedSittings = sortedSittings.sort((testCentre1, testCentre2) => {
      if (testCentre1.testCentreName > testCentre2.testCentreName) {
        return 1;
      }
      if (testCentre1.testCentreName < testCentre2.testCentreName) {
        return -1;
      }
      return 0;
    });
    return sortedSittings;
  }

  getTransferRegions() {
    this.showTestCentre = false;
    this.testCentre = null;
    this.selectedRegion = null;
    this.showRegion = false;
    const deliveryMethodId = this.testRegInfo.isWebDelivery ? DeliveryMethodEnum.Online : DeliveryMethodEnum.TestCentre;
    this.countryRegionService.getTransferRegionsByDeliveryMethodId(this.testRegInfo.brandTestTypeId, deliveryMethodId).subscribe(result => {
      this.regions = result.content;
      if (this.regions.length > 0) {
        this.showRegion = true;
      }
    },
      (error: HttpErrorResponse) => {
        if (error.status === 400) {
          const errorMessage = error.error as HttpErrorResponseMessages;
          errorMessage.reasons.forEach(reasons => {
            this.toastService.warning(reasons.errorMessage);
          });
        }
      });
  }

  getCountrySittings() {
    this.sittingsForSelectedTestCentre = [];
    this.showTestCentre = false;
    this.countryRegionService.getRegionsWithCertainTestType(this.selectedCountry.id, this.testTypeId)
      .subscribe(result => {
        this.regions = result.content;
        this.selectedRegion = this.regions[0];
        this.getRegionSittings();
      },
        (error: HttpErrorResponse) => {
          if (error.status === 400) {
            const errorMessage = error.error as HttpErrorResponseMessages;
            errorMessage.reasons.forEach(reasons => {
              this.toastService.warning(reasons.errorMessage);
            });
          }
        });
  }


  updateSittingsForSelectedTestCentre(sittings: TestSessionForRegistrationDto[], testCentre: TestSessionForRegistrationDto) {
    if (sittings) {
      this.sittingsForSelectedTestCentre = [];
      for (const sitting of sittings) {
        if (sitting.testCentreId === testCentre.testCentreId) {
          this.sittingsForSelectedTestCentre.push(sitting);
        }
      }
    }
  }

  setTestCentre() {
    this.transferPaymentReturned = false;
    this.transferFee = 0.0;
    this.updateSittingsForSelectedTestCentre(this.sittings, this.testCentre);
    this.sittingId = null;
  }

  getRegionSittings() {
    this.testCentres = null;
    this.transferPaymentReturned = false;
    this.transferFee = 0.0;
    if (this.selectedRegion) {
      this.accountService.getTargetRegTransferSessions(this.regId, this.selectedRegion.id).subscribe(result => {
        this.sittings = result.content;
        this.testCentre = null;
        this.testCentres = this.getTestCentres(this.sittings);
        if (this.testCentres.length > 0) {
          this.showTestCentre = true;
        }
      },
        (error: HttpErrorResponse) => {
          if (error.status === 400) {
            const errorMessage = error.error as HttpErrorResponseMessages;
            errorMessage.reasons.forEach(reasons => {
              this.toastService.warning(reasons.errorMessage);
            });
          }
        });
    }
  }

  getTransferFee() {
    if (this.sittingId) {
      this.accountService.getRegTransferPayment(this.testRegInfo.regId, this.sittingId).subscribe(result => {
        this.transferPayment = result.content;
        this.transferFee = result.content.price;
        this.transferPaymentReturned = true;
      },
        (error: HttpErrorResponse) => {
          if (error.status !== 401) {
            const errorMessage = error.error as HttpErrorResponseMessages;
            if (errorMessage?.reasons) {
              errorMessage.reasons.forEach(reasons => {
                this.toastService.warning(reasons.errorMessage);
              });
            }
            else {
              this.toastService.warning("Failed to get test registration payment information because of unknown error. Please contact Paragon.");
            }
          }
        });
    }
  }

  getTestSessionFromSittingList(sittingId: number): TestSessionForRegistrationDto {
    return this.sittings.find(sitting => sitting.id === Number(sittingId));
  }

  transferReg() {
    const request: UserTestRegistrationTransferRequest = {
      sourceRegId: this.testRegInfo.regId,
      targetTestSessionId: this.sittingId,
    };
    this.accountService.transferReg(request)
      .subscribe(() => {
        const priceDifference = this.getTestSessionFromSittingList(this.sittingId).testFee - this.transferPayment.sourceRegPrice;
        this.confirmMessage = "Please note that in addition to the " + this.transferPayment.currencyCode + " " + this.transferFee + ".00 transfer fee, an additional " + this.transferPayment.currencyCode + " " + priceDifference + ".00 will be charged to accommodate for the difference in test cost.";
        if (priceDifference > 0) {
          this.confirmationModal.open();
        } else {
          this.router.navigate(['shopping-cart']);
        }
      },
        (error: HttpErrorResponse) => {
          if (error.status === 400) {
            const errorMessage = error.error as HttpErrorResponseMessages;
            errorMessage.reasons.forEach(reasons => {
              this.toastService.warning(reasons.errorMessage);
            });
          } else {
            this.toastService.warning("Failed to get test registration payment information because of unknown error. Please contact Paragon.");
          }
        });
  }

  routeToShoppingCart() {
    this.router.navigate(['shopping-cart']);
  }

  public get TestTypeEnum() {
    return TestTypeEnum;
  }
}
